export abstract class AutomationFunctionCodes {
  static readonly UserAdmin = "ZN6M2L2E"; //1
  static readonly AddDNA = "PGEMUDQE"; //2
  static readonly ModifyDNA = "QBVTCSY8"; //3
  static readonly DNAAdmin = "FNBZ543J"; //4
  static readonly ProductManager = "ERWOAXIW"; //5
  static readonly DNAManager = "TUG9GVXE"; //6
  static readonly ErrorCheck = "02UABN3W"; //7
  static readonly ComponentCount = "SW0FXQKQ"; //8
  static readonly CableEstimation = "09C9WCW8"; //9
  static readonly BillOfQuantities_CAD = "CM9WXNNG"; //10
  static readonly ImportSheetData = "ZJBJ55JS"; //11
  static readonly ImportTagData = "Y5L82IBA"; //12
  static readonly ExportSheetData = "V0SG6PMH"; //13
  static readonly ExportTagData = "GH6F0RNT"; //14
  static readonly ComponentNumber = "D56KH1YZ"; //15
  static readonly HardwareSheet_AACS = "XJABRBBO"; //18
  static readonly EquipmentSheet_AACS = "URASTHUD"; //18
  static readonly HardwareSheet_CCTV = "EFBFXHPC"; //32
  static readonly HardwareSheet_IHAS = "G50NRPP5"; //43
  static readonly RevisionTracker_AACS = "LXSQO5ZT"; //19
  static readonly RevisionTracker_CCTV = "54HFUW6A"; //33
  static readonly RevisionTracker_IHAS = "AHZWBD57"; //44
  static readonly DoorWizard = "B5A9Z8UU"; //20
  static readonly BillofQuantities_AACS = "Z136P16W"; //21
  static readonly BillofQuantities_CCTV = "Q9WMUE0G"; //35
  static readonly BillofQuantities_IHAS = "OVSPU81T"; //45
  static readonly CommissioningSheets_AACS = "UHQL6WWL"; //23
  static readonly CommissioningSheets_CCTV = "FPEZJEOM"; //41
  static readonly CommissioningSheets_IHAS = "Z9XUTRHK"; //50
  static readonly Schematics_AACS = "Y1BBZ8R7"; //24
  static readonly Schematics_CCTV = "0NMK4LM2"; //38
  static readonly Schematics_IHAS = "FJDCB8CO"; //47
  static readonly HardwareOAndMManual_AACS = "1DMW48W4"; //25
  static readonly HardwareOAndMManual_CCTV = "BXPFKIAM"; //39
  static readonly HardwareOAndMManual_IHAS = "NBJDQNJY"; //48
  static readonly SystemConfigurationFiles_AACS = "ETU7ASWE"; //26
  static readonly SystemConfigurationFiles_CCTV = "7W3QZH7O"; //40
  static readonly ReverseAutomatorAacs = "8X5UDNCX"; //27
  static readonly ReverseAutomatorCctv = "5G2HRUSZ";
  static readonly ClearanceImporter = "557Y2IPE"; //28
  static readonly SystemConversionToHardwareSheet = "QGI3UM7K"; //29
  static readonly UpdateMigrator800 = "9FWA3N3V"; //30
  static readonly HelpSearch = "RBYXEALT"; //51
  static readonly FAQ = "ELEZG4GC"; //52
  static readonly FAQAdmin = "1SZXNBFD"; //53
  static readonly PageContentAdmin = "D9ZCS0MT"; //54
  static readonly DesignAssistant = "CEVDB802"; //55
  static readonly TicketManagement = "S5Q154Q7"; //56
  static readonly AnnouncementManager = "V876G8N7"; //57
  static readonly FileManagement = "3VWXQRBE"; //58
  static readonly FileCategoryMangement = "CN2KPQY5"; //59
  static readonly DesignWizard_AACS = "GKNHAFT6"; //60
  static readonly DesignWizard_CCTV = "498LIS76"; //61
  static readonly DesignWizard_IHAS = "3IDD9YUO"; //62
  static readonly DesignToDestination_AACS = "723URX8M"; //63
  static readonly DesignToDestination_CCTV = "H385CFG5"; //64
  static readonly DesignToDestination_IHAS = "G3P7LI3E"; //65
  static readonly UnitConverter = "VUUIJ2Y2"; //66
  static readonly UnitConverterAdmin = "Z3S5LBWB"; //67
  static readonly CADLibrary = "OT7OPZIJ"; //69
  static readonly CADLibraryAdmin = "IK593C3E"; //70
  static readonly MenuManagement = "VPEP92Y1"; //74
  static readonly RoleManagement = "2GK4XUOV"; //76
  static readonly FunctionBundle = "ZHNTQR8J"; //77
  static readonly FunctionManagement = "JZ4CZN2W"; //78
  static readonly PartialAccessManagement = "0MI03JL9"; //79
  static readonly DepartmentsAdmin = "5O6WNWVB"; //80
  static readonly BudgetWizard = "F9O8G8JT"; //82
  static readonly UserSettings = "7LJ8297N"; //84
  static readonly StorageAndBandwithCalculator = "VNXJRJ4G"; //85
  static readonly Resources = "EXPYP1OL"; //86
  static readonly HelpCentre = "9XY1ZJTS"; //87
  static readonly SupportTickets = "P5MUC6SK"; //88
  static readonly EightHundredUpdateMigrator = "9FWA3N3V";
  static readonly PanelPricingWizard_AACS = "xFs4Fh";
  static readonly PanelPricingWizard_CCTV = "xCs4Fx";
  static readonly PanelPricingWizard_IHAS = "xQs4Fy";
  static readonly  DocumentGenerator = "AG72LTV4";
  static readonly CommissioningSheetToHardwareSheet_AACS = "CPOY86D4";
  static readonly CommissioningSheetToHardwareSheet_CCTV = "DBIF51R5";
  static readonly CommissioningSheetConversion_AACS = "8FVD8LFF";

  static readonly EightHundredBoardConversionCommissioningSheet = "D5MU26SK";

  //TODO db de olmayanlar
  //static readonly ResetPassword = "FCVHR4KV";
  //static readonly Weather = "W6T99WPB";
  //static readonly UserEdit = "L23WB8U2";
  //static readonly Section = "QW7P2TMU";
  //static readonly Recover = "Q7TN4DW7";
  //static readonly MenuAdmin = "NZZZ9PMD";
  //static readonly FormatDrawings = "7FMDR6N8";
  //static readonly FunctionCategoryManagement = "ATPLD9RC";
  //static readonly FunctionShortcut = "HA7GNDNJ";
  //static readonly CadFileEdit = "LTFD8WTS";
  //static readonly CategoryType = "XG4RHSN4";
  //static readonly Dropbox = "KR9ZRMAS";
  //static readonly EightHundredUpdateMigrator = "TQW8XJH8";
  //static readonly UserListView = "XKUYDGXM";
  //static readonly StatsView = "7XG9WN7L";
  //static readonly Authenticatio = "MCNXE64G";
  //static readonly AdminListView = "AQKPFRK9";
  //static readonly UserLoginActivity = "MWWVQNNW";
  //static readonly BundleAdmin = "PUS7YMH3";
  //static readonly DeviceList = "6DJK54XG";
  //static readonly Sidebar = "MUXFMUH8";
  //static readonly AssetAdmin = "NBZR2RBV";
  //static readonly DrawingMainMenu = "RRE2URPE";
  //static readonly UserFunction = "M5ANPUCA";
}

